import AOS from 'aos';
import 'aos/dist/aos.css';

export const initAOS = () => {
  AOS.init({
    duration: 400,         // Animoinnin kesto millisekunteina
    easing: 'linear',  // Easing-tyyli
    once: true,            // Animoidaanko vain kerran
    mirror: false,         // Toistaako animaatio kun vierität takaisin ylös
    offset: 120,           // Etäisyys, jolloin animaatio käynnistyy
    delay: 0               // Globaalisti lisättävä viive
  });
};
